/**
 * Шина событий для внутреннего баннера N-06 (CLIENT_WEB.md §8.6).
 *
 * Баннер показывает то, что пришло, ПОКА вкладка видима: системное
 * уведомление в этот момент не показывается (CC §9.6, «foreground»),
 * а знать о событии пользователю всё равно нужно.
 *
 * Отдельная шина, а не состояние в сторе: событие живёт секунды и не
 * является частью состояния приложения.
 */
import type { Match, Message } from '@shared/api/types'

export type InAppEvent = { kind: 'message'; message: Message } | { kind: 'match'; match: Match }

type Listener = (event: InAppEvent) => void

const listeners = new Set<Listener>()

export function emitInAppEvent(event: InAppEvent): void {
  // §8.6: баннер — только при видимой вкладке; иначе событие обрабатывает push.
  if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return
  for (const listener of listeners) listener(event)
}

export function subscribeInAppEvents(listener: Listener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
